module.exports = __webpack_public_path__ + "img/car.fc43aa69.png";